import * as Actions from '../../actions/register/index';

const initialState = false;

const loading = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.SET_LOADING:
        {
            return action.payload;
        }

        case Actions.REMOVE_LOADING:
        {
            return initialState;
        }
        
        default:
        {
            return state;
        }
    }
}

export default loading;